import { useContext, useState } from "react";
import { getManagementCompaniesRequest } from "src/services/admin/queries/managementCompanies";

import Context from "../../context";

const useGetManageCompanies = () => {
	const [isLoading, setLoading] = useState(false);
	const { actions } = useContext(Context);

	const getManageCompanies = async (
		page: number,
		term: string,
		nullCifOnly: boolean,
		callback?: () => void
	) => {
		setLoading(true);
		getManagementCompaniesRequest(term, nullCifOnly, page, 10)
			.then((response) => {
				actions.setData(response.items);
				if (response.totalItems) {
					actions.setTotalItems(response.totalItems);
				}
				callback?.();
				setLoading(false);
			})
			.catch(() => {
				setLoading(false);
			});
	};

	return { isLoading, getManageCompanies };
};

export default useGetManageCompanies;
